import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Message } from 'primereact/message';
import { AnexosComponent } from '../../../../components/AnexosComponent';
import { ClientePjService } from '../../../../service/trust/ClientePjService';
import { useLazyParams } from '../../../../hooks/useLazyParams';
import { DataView } from 'primereact/dataview';
import { PnService } from '../../../../service/trust/certificacion/PnService';
import * as generic from '../../../../components/Generico';


export const GestorAnexosArbol = ({ visible, onHide, clipjId, toast, permss }) => {
    const [loading, setLoading] = useState(false);
    const [arbol, setArbol] = useState(null);
    const clientePjServicio = new ClientePjService();
    const certificacionPnServicio = new PnService();
    const [dialogAnexo, setDialogAnexo] = useState(false);
    const [anexoConfig, setAnexoConfig] = useState(null);
    const fideicomisos = useLazyParams({ initialRows: 3 });

    const urlsCertPj = {
        urlListado: 'ficha/trust/certificacion-pj',
        urlUpload: 'ficha/trust/certificacion-pj/store',
        urlDownload: 'ficha/trust/certificacion-pj/descarga',
        uaprobar: 'ficha/trust/certificacion-pj/aprobar',
        udelete: 'ficha/trust/certificacion-pj/eliminar-anexo',
    };

    const urlsCertPn = {
        urlListado: 'ficha/trust/certificacion-pn',
        urlUpload: 'ficha/trust/certificacion-pn/store',
        udelete: 'ficha/trust/certificacion-pn/eliminar-anexo',
        urlDownload: 'ficha/trust/certificacion-pn/descarga',
        uaprobar: 'ficha/trust/certificacion-pn/aprobar',
    };

    useEffect(() => { // Cargar el árbol principal (CertificacionPJ y los 3 PNs principales)
        if (visible && clipjId) {
            consultarCertificaciones();
        }
        // eslint-disable-next-line
    }, [visible, clipjId]);

    const consultarCertificaciones = () => {
        setLoading(true);
        setArbol(null);
        fideicomisos.setData([]);

        clientePjServicio.getArbolAnexos(clipjId).then(res => {
            setArbol(res.data);
        }).catch(error => {
            generic.funcSistemaError(error, toast);
        }).finally(() => {
            setLoading(false);
        });
    };

    useEffect(() => { // Disparador para la paginación de Fideicomisos usando el ID estandarizado
        if (arbol?.certPj?.id) {
            cargarFideicomisosPaginados();
        }
        // eslint-disable-next-line
    }, [arbol?.certPj?.id, fideicomisos.lazyParams]);

    const cargarFideicomisosPaginados = () => {
        fideicomisos.setLoading(true);
        const payload = {
            lazyEvent: JSON.stringify({ ...fideicomisos.lazyParams, idp: arbol.certPj.id })
        };

        certificacionPnServicio.getLista(payload).then(res => {
            fideicomisos.setData(res.data.registros || []);
            fideicomisos.setTotalRecords(res.data.total || 0);
        }).finally(() => fideicomisos.setLoading(false));
    };

    const abrirAnexos = (tipo, idp, estado, urls) => {
        setAnexoConfig({ tipo, idp, estado, urls, soloLectura: estado === 'FINALIZADO' });
        setDialogAnexo(true);
    };

    const Inversion = arbol?.hijosPn?.find(h => h.inversion_id);
    const Deposito = arbol?.hijosPn?.find(h => h.deposito_id);
    const Pasiva = arbol?.hijosPn?.find(h => h.pasiva_id);

    const obtenerNombreRegistro = (registro) => {
        if (!registro) return 'Sin datos';
        if (registro.razon_social) return registro.razon_social;
        return `${registro.nombres || ''} ${registro.apellidos || ''}`.trim() || 'Sin datos';
    };

    const renderFila = (titulo, icono, registro, tipo, urls) => {

        return (
            <div className="flex align-items-center justify-content-between gap-3 p-3 mb-2 surface-100 border-round shadow-1">
                <div className="flex align-items-center gap-3 overflow-hidden">
                    <i className={`${icono} text-xl text-primary flex-shrink-0`}></i>
                    <div className="overflow-hidden">
                        <span className="block font-bold text-700 text-sm md:text-base truncate">
                            {titulo}
                        </span>
                        <span className="block text-sm text-800 font-medium mt-1 truncate">
                            {obtenerNombreRegistro(registro)}
                        </span>
                        {registro?.estado && (
                            <span className="block text-xs text-500 mt-1">
                                Estado: {registro.estado}
                            </span>
                        )}
                    </div>
                </div>
                <Button
                    icon="pi pi-folder-open"
                    label="Anexos"
                    className="p-button-outlined p-button-sm flex-shrink-0"
                    style={{ width: '110px' }}
                    onClick={() => abrirAnexos(tipo, registro.id, registro.estado, urls)}
                />
            </div>
        );
    };

    const fideicomisoTemplate = (fideicomiso) => {
        return (
            <div className="col-12 p-0">
                {renderFila('Persona Fideicomiso', 'pi pi-user', fideicomiso, 'fideicomiso', urlsCertPn)}
            </div>
        );
    };

    const actualizarEstadoRegistro = (nuevoEstado) => {
        if (!nuevoEstado || !anexoConfig) return;

        const { tipo, idp } = anexoConfig;

        if (tipo === 'certificacionPj') { // Si es la certificación PJ principal
            setArbol(prev => ({ ...prev, certPj: { ...prev.certPj, estado: nuevoEstado } }));
        } else if (['inversion', 'deposito', 'pasiva'].includes(tipo)) { //  Si es uno de los hijos principales (Inversión, Depósito, Pasiva)
            setArbol(prev => ({ ...prev, hijosPn: prev.hijosPn.map(hijo => hijo.id === idp ? { ...hijo, estado: nuevoEstado } : hijo) }));
        } else if (tipo === 'fideicomiso') {  // Si es parte de la tabla paginada de fideicomisos
            const nuevaData = fideicomisos.data.map(f => f.id === idp ? { ...f, estado: nuevoEstado } : f);
            fideicomisos.setData(nuevaData);
        }

        // Actualizamos la config actual del modal por si el usuario lo mantiene abierto
        setAnexoConfig(prev => ({ ...prev, estado: nuevoEstado, soloLectura: nuevoEstado === 'FINALIZADO' }));
    };

    return (
        <>
            <Sidebar visible={visible} onHide={onHide} position="right" style={{ width: '500px' }} className="p-sidebar-md">
                <h2 className="text-xl font-bold mb-4">Gestor de Anexos: Auto-certificaciones</h2>

                {loading && <span className="block mb-3 text-600"><i className="pi pi-spin pi-spinner mr-2"></i>Cargando estructura...</span>}

                {!loading && !arbol?.certPj && (
                    <Message severity="info" text="Este cliente aún no tiene una Auto-certificación PJ iniciada." className="w-full" />
                )}

                {!loading && arbol?.certPj && (
                    <div className="flex flex-column gap-2">
                        <h3 className="text-lg mt-0 mb-2">Residencia Fiscal Sociedad</h3>
                        {renderFila('Auto-certificación Sociedad', 'pi pi-building', arbol.certPj, 'certificacionPj', urlsCertPj)}

                        <h3 className="text-lg mt-4 mb-2">Personas que ejercen el control</h3>

                        {Inversion && renderFila('Institución Financiera o Entidad de Inversión', 'pi pi-briefcase', Inversion, 'inversion', urlsCertPn)}
                        {Deposito && renderFila('Entidad de Depósito, Custodia, o Compañía de Seguros', 'pi pi-lock', Deposito, 'deposito', urlsCertPn)}
                        {Pasiva && renderFila('Entidad No Financiera Pasiva', 'pi pi-chart-pie', Pasiva, 'pasiva', urlsCertPn)}

                        <span className="block mt-3 mb-2 font-semibold text-600">Personas que ejercen el control sobre la sociedad titular del fideicomiso</span>

                        <DataView value={fideicomisos.data} itemTemplate={fideicomisoTemplate} lazy paginator first={fideicomisos.lazyParams.first}
                            rows={fideicomisos.lazyParams.rows} totalRecords={fideicomisos.totalRecords} onPage={fideicomisos.onLazyChange} loading={fideicomisos.loading}
                            emptyMessage="No se encontraron personas de fideicomiso." className="w-full" />
                    </div>
                )}
            </Sidebar>

            <Dialog visible={dialogAnexo} header={`Gestión de Anexos`} modal className="p-fluid modal-ssize dialog-personalizado" onHide={() => setDialogAnexo(false)} style={{ width: '800px' }}>
                {anexoConfig && (
                    <AnexosComponent tipo={anexoConfig.tipo} urls={anexoConfig.urls} idp={anexoConfig.idp} toast={toast} permss={permss} setDialogSubir={setDialogAnexo} soloLectura={anexoConfig.soloLectura} estado={anexoConfig.estado} reiniciar={(nuevoEstado) => actualizarEstadoRegistro(nuevoEstado)} />
                )}
            </Dialog>
        </>
    );
}